<template>
    <form @submit.prevent="submit" class="w-full">
        <label for="name" class="text-sm">Titolo Slide</label>
        <input type="text" v-model="form.name" placeholder="Titolo" class="w-full mb-2" />
        <label for="name" class="text-sm">Link</label>
        <input type="text" v-model="form.link" placeholder="https://virtual-coach.it/" class="w-full my-2" />
        <div class="w-full">
            <span class="text-sm">Slide immagine</span>
            <label class="flex flex-col items-center justify-center w-full h-20 mt-1 tracking-wide uppercase bg-white border border-gray-300 rounded-lg cursor-pointer hover:bg-pink-600 hover:text-white">
                <svg v-show="!showPreview" class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"/>
                </svg>
                <span v-show="!showPreview" class="mt-2 text-base leading-normal">Aggiungi immagine</span>
                <input type="file" name="avatar" class="hidden" id="avatar" @change="onFileChange">      
                <img v-bind:src="imagePreview" class="w-20 h-20" v-show="showPreview"/> 
            </label>
            <div v-if="message.length > 0" class="font-semibold text-red-600">{{ message }}</div>
        </div>
        <!-- <input type="file" @input="form.avatar = $event.target.files[0]" class="my-2"/>
        <progress v-if="form.progress" :value="form.progress.percentage" max="100" class="w-full">
            {{ form.progress.percentage }}%
        </progress> -->
        <div v-show="!isActive">
            <button :disabled="!isComplete" :class="isComplete ? '' : 'opacity-50 cursor-not-allowed'" type="submit" class="w-full my-2 text-center text-white bg-green-500 rounded-md shadow-md ">Upload</button>
        </div>
        <div v-show="isActive" class="w-full my-2 text-center text-white bg-blue-500 rounded-md shadow-md">
            slide updated!!
        </div>
    </form>
</template>

<script>
    export default {
        data() {
            return {
                imagePreview: null,
                showPreview: false,
                form: {
                    name: null,
                    link: null,
                    avatar: null,
                },
                message: '',
                isActive: false
            }
        },
        computed: {
            isComplete(){
                return this.form.name && this.form.link && this.form.avatar;
            }
        },
        methods: {
            onFileChange(event) {
                this.form.avatar = event.target.files[0];
                let reader  = new FileReader();

                if( this.form.avatar ){
                    if( /\.(jpeg|jpg|png)$/i.test( this.form.avatar.name ) ) {
                        this.message = "";
                        reader.addEventListener("load", function () {
                            this.showPreview = true;
                            this.imagePreview = reader.result;
                        }.bind(this), false);
                        reader.readAsDataURL( this.form.avatar );
                    } else {
                        this.message = "only jpg, png and jpeg accepted";
                    }
                }
            },

            submit() {
                // this.form.post(this.route('slideupload'))
                let custObj = this;
                const data = new FormData()
                data.append('name', this.form.name);
                data.append('link', this.form.link);
                data.append('avatar', this.form.avatar);

                const token = localStorage.getItem('token');
                const headers = { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                };
                this.isActive = true;
                axios.post("/slideupload",data,{headers})
                .then(function (response) {
                    custObj.$emit('changeSlides',response.data.allSlides)
                })
                .catch(function (error) {
                    custObj.isActive = false;
                    console.log(error);
                });

            },
        },
    }
</script>